import { cn } from "@/modules/helpers/hooks/shared/utils";

export const FilterTab = ({
  tabs,
  active,
  onChange
}: {
  tabs: { key: string; label: string; count: number }[]
  active: string
  onChange: (key: string) => void
}) => {
  const activeIndex = tabs.findIndex((t) => t.key === active)

  return (
    <div className="relative flex border-b border-gray-200 w-fit">
      {/* indicator chạy qua lại */}
      <span
        className="absolute bottom-0 h-[1px] bg-gradient-to-r from-primary to-secondary transition-transform duration-300 ease-in-out"
        style={{
          width: `${100 / tabs.length}%`,
          transform: `translateX(${activeIndex * 100}%)`
        }}
      />

      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onChange(tab.key)}
          className={`relative flex-1 flex gap-2 px-3 items-center py-2 text-sm font-normal transition-colors ${
            active === tab.key ? "text-primary" : "text-gray-500 hover:text-gray-700"
          }`}
        >
          <span className="whitespace-nowrap">{tab.label}</span>
          <span
            className={cn(
              "ml-1 text-[10px] text-white bg-gray-500 w-6 h-6 flex justify-center items-center rounded-sm font-medium",
              {
                "text-white bg-primary": active === tab.key
              }
            )}
          >
            {tab.count}
          </span>
        </button>
      ))}
    </div>
  )
}
